import { Token } from 'types/security/token';
import { authentificationApi } from 'network/api/AuthentificationApi';
import sessionManager from 'services/sessionManager';
import { LogInFormType } from 'types/forms/LogInFormType';
import { SignInFormType } from 'types/forms/SignInFormType';

const FIVE_MINUTES_IN_MS = 1000 * 60 * 5;

export class SessionService {
  // eslint-disable-next-line no-undef
  private timeout: NodeJS.Timeout | null = null;

  async logIn(loginData: LogInFormType) {
    const response: Token = await authentificationApi.logIn(loginData);
    sessionManager.setCurrentToken(response.token);
    sessionManager.setRefreshToken(response.refreshToken);
    this.scheduleRefreshSession();
  }

  async signIn(signInData: SignInFormType) {
    const response: Token = await authentificationApi.signIn(signInData);
    sessionManager.setCurrentToken(response.token);
    sessionManager.setRefreshToken(response.refreshToken);
    this.scheduleRefreshSession();
  }

  async getSessionFromFirebase(token: string) {
    const response: Token = await authentificationApi.getTokenFromFirebase(token);
    sessionManager.setCurrentToken(response.token);
    sessionManager.setRefreshToken(response.refreshToken);
    this.scheduleRefreshSession();
  }

  async createSessionFromFirebase(token: string) {
    const response: Token = await authentificationApi.firebaseSignIn(token);
    sessionManager.setCurrentToken(response.token);
    sessionManager.setRefreshToken(response.refreshToken);
    this.scheduleRefreshSession();
  }

  scheduleRefreshSession() {
    if (!this.timeout) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        const refreshToken = sessionManager.getRefreshToken();
        if (refreshToken) {
          this.refreshSession(refreshToken);
        }
      }, FIVE_MINUTES_IN_MS);
    }
  }

  logOut() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    sessionManager.setCurrentToken(undefined);
    sessionManager.setRefreshToken(undefined);
  }

  async refreshSession(token: string) {
    try {
      const response: Token = await authentificationApi.refreshToken(token);
      sessionManager.setCurrentToken(response.token);
      if (response.refreshToken) {
        sessionManager.setRefreshToken(response.refreshToken);
      }
      this.scheduleRefreshSession();
    } catch {
      // eslint-disable-next-line no-console
      console.log('Error getting session with refresh token');
    }
  }
}

const sessionService = new SessionService();
export default sessionService;
